import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sc-control-panel" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col mt-3" }
const _hoisted_5 = { class: "d-flex align-items-start" }
const _hoisted_6 = {
  class: "nav nav-pills flex-column me-3",
  "aria-orientation": "vertical"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi-calendar-check" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "面板", -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<a class=\"nav-link py-1\" href=\"#\"><i class=\"bi-plus-square\"></i><span class=\"ms-2\">业务</span></a><a class=\"nav-link py-1\" href=\"#\"><i class=\"bi-shield-lock\"></i><span class=\"ms-2\">账号</span></a>", 2)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi-door-open" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "退出", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "tab-content flex-fill" }
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = { class: "col mt-3 d-flex flex-column align-items-center" }
const _hoisted_17 = { class: "card col-xl-5 col-md-6" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "input-group mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-person-circle text-info" })
], -1)
const _hoisted_21 = { class: "input-group mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-shield-lock-fill text-info" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group mt-3 d-grid gap-2" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-info",
    "aria-label": "submit"
  }, "登录")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.userStatus.identity)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    replace: "",
                    class: "nav-link py-1",
                    to: { name: "auth" }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _hoisted_9,
                  _createElementVNode("a", {
                    class: "nav-link py-1",
                    href: "/a/service/api/Account/Logout",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitLogout && _ctx.submitLogout(...args)), ["prevent"]))
                  }, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_router_view)
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("form", {
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitContent && _ctx.submitContent(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "账号",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageModel.account) = $event)),
                        "aria-label": "username",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.pageModel.account]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("input", {
                        type: "password",
                        class: "form-control",
                        placeholder: "密码",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageModel.password) = $event)),
                        "aria-label": "password",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.pageModel.password]
                      ])
                    ]),
                    _hoisted_23
                  ], 32)
                ])
              ])
            ])
          ]))
    ])
  ]))
}